export const LOCAL_STORAGE_PREFIX = 'dha.accounting.webapp';
export const DATE_FORMAT = 'YYYY-MM-DD';
export const NUMBER_FORMAT = '0,0.[0000]';
export const INTEGER_FORMAT = '0,0';

export const StorageKey = {
  ACCESS_TOKEN: 'access_token',
  SPACE_TOKEN: 'space_token',
  CURRENT_SPACE: 'current_space',
  PERIOD: 'period',
  TOUR_PARAMS: 'tour_params',
};

export const DefaultCurrency = 'VND';
export const CurrencyRate = {
  VND: 1,
  USD: 23000,
  EUR: 26000,
  JPY: 220,
};

export const CURRENCY_EXCHANGE_FIELDS = {
  sale: ['discount_amount', 'total_price', 'price'],
  purchase: ['discount_amount', 'total_price', 'price'],
};

export const DefaultSalaryParams = {
  enable_random_leave_days: true,
  refine_manual_salary: false,

  production_salary_method: 'none',
  sale_salary_method: 'none',
  management_salary_method: 'none',

  align_production_salary_by_revenue: true,
  align_sale_salary_by_revenue: true,
  align_management_salary_by_revenue: true,

  product_salary: 0,
  commission_rate: 0,
};



// WEBPACK FOOTER //
// ./src/constant.js